import { ReactNode } from 'react';

interface DetailBadgeProps {
  icon: ReactNode;
  color: string;
  bgColor: string;
  label: string;
}

export function DetailBadge({ icon, color, bgColor, label }: DetailBadgeProps) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.4rem',
        fontSize: '0.75rem',
        fontWeight: 600,
        color,
        background: bgColor,
        padding: '0.35rem 0.6rem',
        borderRadius: '6px',
      }}
    >
      {icon}
      <span>{label}</span>
    </div>
  );
}
